<template>
  <div id="app" class="wrapper">
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta" :style="{ color: corTexto }">Meus dados</h1>

        <div class="modal-body">
          <div
            id="listandoendereco"
            :style="{ color: corTexto }"
            class="col-md-14"
          >
            <div class="form-group">
              <label class="col-md-4 control-label" for="nomecompleto"
                >Nome Completo :
              </label>
              <div class="col-md-10">
                <input
                  type="text"
                  id="nomecompleto"
                  name="nomecompleto"
                  v-model="nomecompleto"
                  placeholder="Nome Completo"
                  class="form-control input-md"
                  required="required"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label" for="email"
                >Endereço de email</label
              >
              <div class="col-md-10">
                <input
                  type="email"
                  class="form-control input-md"
                  id="email"
                  name="email"
                  v-model="email"
                  aria-describedby="emailHelp"
                  placeholder="Seu Email"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label" for="senha">Senha</label>
              <div class="col-md-10">
                <input
                  type="password"
                  class="form-control input-md"
                  id="senha"
                  name="senha"
                  v-model="senha"
                  placeholder="Senha"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label" for="confirmaSenha"
                >Confirmar Senha</label
              >
              <div class="col-md-10">
                <input
                  type="password"
                  class="form-control input-md"
                  id="confirmaSenha"
                  name="confirmaSenha"
                  v-model="confirmaSenha"
                  placeholder="Confirmar Senha"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label" for="telefone"
                >Telefone :
              </label>
              <div class="col-md-10">
                <input
                  type="text"
                  id="telefone"
                  name="telefone"
                  v-model="telefone"
                  placeholder="(99) 99999-9999"
                  class="form-control input-md"
                  required="required"
                  maxlength="15"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="
              color: #fff;
              border-color: #343a40;
              background-color: #006400;
            "
            type="button"
            class="btn btn-dark"
            @click="cadastrarUsuario()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style >
.form-control {
  padding: 0.25rem 0.25rem !important;
}
</style>
<script>
import Inis from "../services/inis";
import Usuario from "../services/usuario";
import Swal from "sweetalert2";

export default {
  name: "Cadastro",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      email: "",
      senha: "",
      confirmaSenha: "",
      nomecompleto: "",
      telefone: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      bairroCidade: [],
      listarendereco: false,
      bairros: "",
      cidades: "",
      estados: "",
      listaAdicionais: "",
      usuario: [],
      emailExistente: "",
      corFundo: "",
      corTexto: "",
      corBotao: "",
      tipoLogin: "",
    };
  },
  methods: {
    //listarinis
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.tipoLogin = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
    },
    validarTelefone(telefone) {
      return telefone.length >= 10 && telefone.length <= 11;
    },
    validarEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return regex.test(email);
    },
    async cadastrarUsuario() {
      this.telefone = this.telefone.replace(/\D/g, "");
      if (this.email == "") {
        Swal.fire({
          title: "Preencha um email válido",
          confirmButtonColor: "#000000",
        });
      } else if (!this.validarEmail(this.email)) {
        Swal.fire({ title: "Email inválido", confirmButtonColor: "#000000" });
      } else if (this.senha != this.confirmaSenha && this.senha!="") {
        Swal.fire({
          title: "Senhas precisam ser iguais",
          confirmButtonColor: "#000000",
        });
      } else if (this.nomecompleto == "") {
        Swal.fire({
          title: "Digite o seu nome completo",
          confirmButtonColor: "#000000",
        });
      } else if (this.telefone == "") {
        Swal.fire({
          title: "Digite o seu número de telefone",
          confirmButtonColor: "#000000",
        });
      } else if (!this.validarTelefone(this.telefone)) {
        Swal.fire({
          title: "Digite um número no formato correto.",
          confirmButtonColor: "#000000",
        });
      } else {
        Usuario.listandoEmail(this.email, this.telefone).then(
          async (resposta) => {
            if (resposta.data != null) {
              Swal.fire({
                title: "Email ou Telefone já existente",
                confirmButtonColor: "#000000",
              });
            } else {
              var u = new Object();
              u.email = this.email;
              u.senha = this.senha;
              u.nomecompleto = this.nomecompleto;
              u.telefone = this.telefone;

              localStorage.setItem(
                "email" + localStorage.getItem("contrato"),
                this.email
              );
              var usuario = await Usuario.cadastrarusuario(u);
              
              if (usuario.data == null) {
                Swal.fire({
                  title: "Erro no cadastro",
                  confirmButtonColor: "#000000",
                });
                return;
              } else {
                Swal.fire({
                  title: "Cadastrado com sucesso",
                  confirmButtonColor: "#000000",
                });
                this.$router.push("/login");
              }
            }
          }
        );
      }
    },
  },
  mounted() {
    this.listarinis();
  },
};
</script>